import * as React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ROUTES } from 'vio-constants';

import Login from './pages/Login';

const Gateway: React.FC = (): JSX.Element => (
	<div id='gateway-container'>
		<Routes>
			<Route path={ ROUTES.AUTH } element={ <Login /> } />
			<Route path="*" element={ <Navigate replace to={ ROUTES.AUTH } /> } />
		</Routes>
	</div>
);

export default Gateway;
